<template>
  <div>
    <!-- Header Section -->
    <div class="max-w-6xl mx-auto px-6 py-4">
    <router-link to="/" class="inline-block text-sm text-teal-700 hover:text-teal-900 font-medium">← Back to Home</router-link>
    </div>

<section class="bg-gradient-to-r from-[#fef9f6] to-white py-16 px-6 text-center">
      <h1 class="text-4xl md:text-5xl font-bold text-teal-800 font-serif mb-4">Smile Transformations</h1>
      <p class="text-gray-600 max-w-2xl mx-auto text-lg">
        Discover real results from our advanced cosmetic and restorative dental treatments.
      </p>
    </section>

    <!-- Services with Before-After Images -->
    <section class="py-16 px-6 max-w-6xl mx-auto">
      <h2 class="text-3xl font-bold text-center text-gray-800 mb-12">See the Difference</h2>
      <div class="grid md:grid-cols-2 gap-12">
        <div class="bg-white p-6 rounded-xl shadow-md text-center">
          <img src="/teeth-cleaning.png" alt="Teeth Whitening" class="rounded-lg mb-4 shadow" />
          <h3 class="text-xl font-semibold mb-2">Professional Teeth Cleaning and Polishing (Scaling)</h3>
          <p class="text-gray-600">Remove plaque, stains and calculus for a fresher, healthier smile.</p>
        </div>
        <div class="bg-white p-6 rounded-xl shadow-md text-center">
          <img src="/braces.png" alt="Braces & Alignment" class="rounded-lg mb-4 shadow" />
          <h3 class="text-xl font-semibold mb-2">Braces and Aligners for Smile Correction</h3>
          <p class="text-gray-600">Straighten misaligned teeth with modern braces and invisible aligners.</p>
        </div>
        <div class="bg-white p-6 rounded-xl shadow-md text-center">
          <img src="/dentures.png" alt="Dentures & Prosthetics" class="rounded-lg mb-4 shadow" />
          <h3 class="text-xl font-semibold mb-2">Custom Dentures and Prosthetics</h3>
          <p class="text-gray-600">Regain function and aesthetics with custom-made, comfortable dentures.</p>
        </div>
        <div class="bg-white p-6 rounded-xl shadow-md text-center">
          <img src="/root-canal.png" alt="Root Canal" class="rounded-lg mb-4 shadow" />
          <h3 class="text-xl font-semibold mb-2">Root Canal Treatment </h3>
          <p class="text-gray-600">Save your natural tooth with advanced, pain-free root canal treatment.</p>
        </div>
        <div class="bg-white p-6 rounded-xl shadow-md text-center">
          <img src="/dental-services/kids-dentistry.webp" alt="Pediatric Care" class="rounded-lg mb-4 shadow" />
          <h3 class="text-xl font-semibold mb-2">Pediatric Dentistry (Kids' Dental Care)</h3>
          <p class="text-gray-600">Gentle, specialized care to protect and nurture your child's oral health.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";

export default {
  name: 'ServicesView',
  setup() {
    useHead({
      title: "Dental Services & Smile Transformations | Magnum Dental Clinic Guwahati",
      meta: [
        {
          name: "description",
          content:
            "Explore smile transformation results at Magnum Dental Clinic Guwahati — teeth cleaning, root canal, braces, dentures, and paediatric dentistry with visible before-and-after results.",
        },
        {
          name: "robots",
          content: "index, follow",
        },
        {
          property: "og:title",
          content: "Dental Services & Smile Transformations | Magnum Dental Clinic Guwahati",
        },
        {
          property: "og:url",
          content: "https://www.magnumdentalguwahati.in/services",
        },
      ],
      link: [
        { rel: "canonical", href: "https://www.magnumdentalguwahati.in/services" },
      ],
    });
  },
};
</script>

<style scoped>
/* Optional scoped styles can go here */
</style>
